module.exports = __webpack_public_path__ + "media/images/projects-circle-icons-a35e8d66.png";